import { Blockquote, Container } from "shared/components";

import styles from "./Content057.module.scss";

export const Content057 = ({ payload }) => {
  const fullName = payload?.fullName ?? "";
  const position = payload?.position ?? "";
  const photo = payload?.photo ?? {};
  const quote = payload?.quote ?? "";

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.blockquote}>
          <Blockquote
            image={photo}
            author={fullName}
            position={position}
            quote={quote}
            className={styles.content}
          />
        </div>
      </Container>
    </div>
  );
};

export default Content057;
